import React from 'react';
import styled from 'styled-components';
import { typography, color } from 'styled-system';
const StyledSvg = styled('svg')(typography, color);

const Alert = props => (
  <StyledSvg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2.182c-5.422 0-9.818 4.396-9.818 9.818S6.578 21.818 12 21.818s9.818-4.396 9.818-9.818S17.422 2.182 12 2.182zM12 15a1.02 1.02 0 01.484.125.878.878 0 01.111.071c.04.03.077.061.112.097l-.09-.08A1.006 1.006 0 0113 16l-.004-.086.003.054L13 16a1.018 1.018 0 01-.146.52 1.054 1.054 0 01-.147.187l.08-.09A1.006 1.006 0 0112 17l.085-.004a1.006 1.006 0 01-.052.003L12 17a1.018 1.018 0 01-.52-.146 1.035 1.035 0 01-.187-.147l.09.08A1.006 1.006 0 0111 16l.004.09a1.006 1.006 0 01-.004-.07V16a1.02 1.02 0 01.125-.484.878.878 0 01.071-.111.999.999 0 01.097-.112l-.08.09A1.006 1.006 0 0112 15l-.09.004.072-.004zm0-9c.552 0 1 .522 1 1.167v4.666c0 .645-.448 1.167-1 1.167s-1-.522-1-1.167V7.167C11 6.522 11.448 6 12 6z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </StyledSvg>
);
export default Alert;
